import { render } from "./MixTable.vue?vue&type=template&id=5c02cfba&ts=true"
import script from "./MixTable.vue?vue&type=script&lang=ts"
export * from "./MixTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__